'use client';

import { c as _c } from "react/compiler-runtime";
import './shift-date-group.scss';
import type { useVolunteerRegistrationSheet } from '../../organisms/volunteer-registration-sheet/volunteer-registration-sheet.logic.ts';
import { type VolunteerSlot, formatSlotDateKey } from '../../utils/volunteer-utils.ts';
import { ShiftSlotItem } from '../shift-slot-item/shift-slot-item.tsx';
type Logic = ReturnType<typeof useVolunteerRegistrationSheet>;
export interface ShiftDateGroupProps {
  dateKey: string;
  slots: VolunteerSlot[];
  logic: Logic;
}
export const ShiftDateGroup: React.FC<ShiftDateGroupProps> = t0 => {
  const $ = _c(14);
  const {
    dateKey,
    slots,
    logic
  } = t0;
  let t1;
  if ($[0] !== dateKey) {
    t1 = formatSlotDateKey(dateKey, "short");
    $[0] = dateKey;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <p className="label-sm text-neutral-600">{t1}</p>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== logic || $[5] !== slots) {
    let t4;
    if ($[7] !== logic) {
      t4 = slot => <ShiftSlotItem key={slot.id} slot={slot} logic={logic} />;
      $[7] = logic;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    t3 = slots.map(t4);
    $[4] = logic;
    $[5] = slots;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[9] !== t3) {
    t4 = <ul className="PanelShifts__list flex flex-col p-none m-none gap-comfy-xs">{t3}</ul>;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t2 || $[12] !== t4) {
    t5 = <div className="flex flex-col gap-snug-md">{t2}{t4}</div>;
    $[11] = t2;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};